import {Validator_AcLed_FlyBack} from "./acled_flyback_validator";
import {Ic} from "../../../../models/common";
import {getMaxPowerXFlyback, getMinPower} from "../../../POWER/acdc/acceptor/acdc__common_acceptor";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Range} from "../../../../common/Range";

/**
 * Created by claudio iozzia on 07/07/2017.
 */
export class Validator_AcLed_QR_FlyBack extends Validator_AcLed_FlyBack {
  protected getPoutBounds(ic: Ic, spec: IAppSpec): Range {
    const minPower: number = getMinPower(ic);
    const maxPower: number = getMaxPowerXFlyback(ic, spec);
    return Validator_AcLed_FlyBack.toRange(minPower, maxPower);
  }
}
